var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlumeLockup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-9 0 1200 592",
    style: {
      enableBackground: "new 0 0 1224 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000054226873128871408710000015548343856570265731_);}\n\t.st3{fill:url(#SVGID_00000121995684812259379040000002738005529775901596_);}\n\t.st4{fill:url(#SVGID_00000170280807922445213590000005665781580809079188_);}\n\t.st5{opacity:0.25;fill:#1B1464;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.5,387.6h50.2c11.5,0,20.3,2.8,26.1,8.5c5.5,5.1,8.5,11.8,8.5,20.3c0,11.5-6.3,19.1-18.2,22.6v0.4 c13.9,3.3,22.6,12.8,22.6,26.8c0,9.8-3.6,17.6-9.8,22.9c-6.4,6-15.6,9.2-27.6,9.2h-51.9V387.6z M406.7,433.3 c10.7,0,17.4-5.2,17.4-14.8c0-9.1-6.3-14.5-16.4-14.5h-27.9v29.2H406.7z M409.5,481.6c6.3,0,11-1.8,14-4.8 c2.8-2.7,4.5-6.6,4.5-11.3c0-11.3-8-16.8-19.1-16.8h-29.1v32.9H409.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.2,387.6h20.6v92.8h53.9v18h-74.5V387.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.1,461v-73.5h20.6v73.2c0,14.9,8.2,22.5,24,22.5c15,0,23.5-7.9,23.5-22.8v-72.9H613V461 c0,26.2-17.1,39.3-44.4,39.3C541,500.4,524.1,487.4,524.1,461z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.4,387.6h27.3l18.2,52.7c4.3,13,9.7,37.2,9.7,37.2h0.4c0,0,5.4-24.1,9.5-37.2l17.9-52.7h27.9v110.9h-19.2 v-57.8c0-12.1,1.3-34.6,1.3-34.6h-0.3c0,0-4.6,20.4-8.2,31.4l-21,60.9h-16.7l-21.2-60.9c-3.6-11-8.2-31.4-8.2-31.4h-0.3 c0,0,1.3,22.5,1.3,34.6v57.8h-18.5V387.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M741.3,387.6h81.1v17.6h-60.5v27.4h53.5v16.5h-53.5v31.3h61.8v18h-82.4V387.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.2922,
    y1: 198.946,
    x2: 656.8349,
    y2: 263.8366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2600F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42C1F0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651.8,293.3c0-15-8-27.6-19.1-32c-2.7-1.1-5.5-1.6-8.5-1.6c-0.5,0-1.1,0-1.6,0.1l-0.8,0.1l-3.8,0.3l-0.2,0 l-15,1l-21.3,1.5l-73.6,3.8c-0.3,0-0.7,0-1,0v-0.3c0-41.4,33.6-75,75-75c23.7,0,44.9,11,58.7,28.3 C640.5,219.5,668.4,250,651.8,293.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024714042664927750980000004991174004315063447_",
    gradientUnits: "userSpaceOnUse",
    x1: 659.3745,
    y1: 333.2643,
    x2: 627.2163,
    y2: 184.533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2600F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42C1F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024714042664927750980000004991174004315063447_)"
    },
    d: "M701.1,280.6c0,22.8-13.1,44.2-33.5,54.5 c-8.9,4.5-17.8,6-27.6,6c-8.7,0-16.7-3.1-23.5-8.4c-4.9-3.9-9.1-8.9-12.4-14.8c-1.1-2-2.1-4.2-3-6.4c-2.2-5.6-3.7-11.7-4.2-18.2 h54.9c0,0,0,0,0,0c16.6-43.3-11.3-73.8-11.3-73.8c3.8,0,7.6,0.4,11.3,1.1C679.9,226.2,701.1,250.9,701.1,280.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149367112651501041380000014606015178522175390_",
    gradientUnits: "userSpaceOnUse",
    x1: 590.0189,
    y1: 263.4571,
    x2: 648.5926,
    y2: 295.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42C1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149367112651501041380000014606015178522175390_)"
    },
    d: "M651.8,293.3h-54.9 c-0.1-0.7-0.1-1.4-0.1-2.1c0,0,0,0,0,0c0.8-16.3,11.2-29.4,24.4-31.3c0.3,0,0.5-0.1,0.8-0.1l0.8-0.1c0.5,0,1.1-0.1,1.6-0.1 c3,0,5.8,0.6,8.5,1.6C643.8,265.7,651.8,278.4,651.8,293.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176035895662541352510000003433236989672997306_",
    gradientUnits: "userSpaceOnUse",
    x1: 577.5869,
    y1: 263.1081,
    x2: 540.8348,
    y2: 354.9882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42C1F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176035895662541352510000003433236989672997306_)"
    },
    d: "M640,341.2h-132 c-20.6,0-37.4-16.7-37.4-37.3c0-13.5,7.2-25.3,17.9-31.9c2.7-1.7,5.7-3,8.8-3.9c3.1-0.9,6.3-1.4,9.6-1.5c0.3,0,0.7,0,1,0l73.6-3.8 l21.3-1.5l15-1l0.2,0l3.8-0.3c-0.3,0-0.5,0.1-0.8,0.1c-13.2,1.8-23.5,15-24.4,31.3c0,0,0,0,0,0c0,0.7,0.1,1.4,0.1,2.1 c0.5,6.5,1.9,12.6,4.2,18.2c0.9,2.2,1.9,4.4,3,6.4c3.3,5.9,7.5,11,12.4,14.8C623.2,338.1,631.3,341.2,640,341.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M622.6,259.7c0,0-21.4,6.7-21.4,33.3l-0.5,0.3h-3.9c-0.1-0.7-0.1-1.4-0.1-2.1c0,0,0,0,0,0 c0.8-16.3,11.2-29.4,24.4-31.3c0.3,0,0.5-0.1,0.8-0.1L622.6,259.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlumeLockup);
export default __webpack_public_path__ + "static/media/BlumeLockup.5568af52dca16e3ccaebab984c93279d.svg";
export { ForwardRef as ReactComponent };